import { ChangeDetectionStrategy, Component, OnInit } from '@angular/core'

import { SetColorsService } from 'core'

@Component({
  selector: 'bmprod-share-track-popup',
  templateUrl: './bmprod-share-track-popup.component.html',
  styleUrls: ['./bmprod-share-track-popup.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmprodShareTrackPopupComponent implements OnInit {
  colorSettingsMode = false

  constructor(private setColorsService: SetColorsService) {}

  ngOnInit(): void {
    this.getColorSettingsMode()
  }

  getColorSettingsMode() {
    this.setColorsService.colorSettingsSubject.subscribe(res => {
      this.colorSettingsMode = res
    })
  }
}
